import React, { useEffect, useState } from 'react';

/**
 * Slim animated gold progress bar fixed at the top of the page that tracks
 * the user's scroll position. A premium "you are here" indicator akin to
 * what Stripe / Linear use on long content pages.
 */
const ScrollProgressBar = () => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const handler = () => {
      const h = document.documentElement;
      const total = h.scrollHeight - h.clientHeight;
      const p = total <= 0 ? 0 : Math.min(1, Math.max(0, h.scrollTop / total));
      setProgress(p);
    };
    handler();
    window.addEventListener('scroll', handler, { passive: true });
    window.addEventListener('resize', handler);
    return () => {
      window.removeEventListener('scroll', handler);
      window.removeEventListener('resize', handler);
    };
  }, []);

  return (
    <div
      aria-hidden="true"
      className="fixed top-0 left-0 right-0 z-[60] h-[3px] bg-brand-maroon-dark/30 pointer-events-none"
    >
      <div
        className="h-full transition-[width] duration-100 ease-out"
        style={{
          width: `${progress * 100}%`,
          background:
            'linear-gradient(90deg, #AA8825 0%, #D4AF37 50%, #F3E5AB 100%)',
          boxShadow: '0 0 10px rgba(212,175,55,0.7)',
        }}
      />
    </div>
  );
};

export default ScrollProgressBar;
